<template>

  <div class="scanEr1">
    <div class="scanLogo">
      <img src="@/assets/wechart.png"/>
    </div>
    <div class="fontEr">
      <span style="font-size: 14px;float:left;width: fit-content">关注公众号</span>
      <br>
      <span style="font-size: 12px;color: rgba(51,51,51,0.6);float: right;margin-top: 0.64vh">掌握最新职位动态</span>
    </div>



  </div>

</template>


<script>

export default {

  name: "",

  props: [],

  components: {},

  data() {

    return {}

  },

  methods: {},

  mounted() {


  }

}

</script>


<style type="text/scss" lang="scss" scoped>
.scanEr1{
  width: fit-content;
  height: fit-content;
  display: flex;
  //background: #FEFFFF;
  //
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  .fontEr{
    width:fit-content;
    margin:1.87vh 0.2vw 1.57vh 0.5vw;
  }
  .scanLogo{
    width:50px;
    height:50px;
    padding: 10px;
    border-radius: 50%;
    background-color: #f4f5f6;
    box-shadow: -2px -1px 0px 3px #d7ecfd;
    margin:1.57vh 0.3vw auto 0.8vw
  }

}

</style>
